import { Row, Col, Card } from 'antd'
import { maskCurrency } from '../../utils/functions'
import moment from 'moment'

const asa = [
    {
        title: 'Total '+process.env.REACT_APP_NAME+' USD',
        key: 'saldoQuery',
        index: 'totalSaidaUsd',
        currency: 'US$'
    },
    {
        title: 'Total Clientes '+process.env.REACT_APP_NAME,
        key: 'saldoQuery',
        index: 'totalClientesFlow',
        currency: 'R$'
    },
    {
        title: `Lucro ${process.env.REACT_APP_NAME} ${moment().subtract(1, 'month').format("MM/YYYY")}`,
        key: 'lucro',
        index: 'totalLucroFlow',
        currency: 'R$'
    },
    {
        title: `Total de aportes`,
        key: 'totalAportes',
        index: 'totalAportes',
        currency: 'R$'
    },
    {
        title: `Total de resgates`,
        key: 'totalResgates',
        index: 'totalResgates',
        currency: 'R$'
    },
    {
        title: `Total investido (Sem rendimentos)`,
        key: 'somaTotal',
        index: 'somaTotal',
        currency: 'R$'
    },
]

const spirit = [
    {
        title: 'Total '+process.env.REACT_APP_NAME+' USD',
        key: 'saldoQuery',
        index: 'totalSaidaUsd',
        currency: 'US$'
    }, 
    {
        title: 'Total AUM',
        key: 'saldoQuery',
        index: 'totalClientesFlow',
        currency: 'R$'
    },
    {
        title: 'Diferencial AUM e Σ clientes',
        key: 'saldoQuery',
        index: 'desvio',
        currency: 'R$'
    },
    {
        title: `Lucro ${process.env.REACT_APP_NAME} ${moment().subtract(1, 'month').format("MM/YYYY")}`,
        key: 'lucroSpirit',
        index: 'totalLucroFlow',
        currency: 'R$'
    },
    {
        title: `Total AUM início ${moment().subtract(1, 'month').format("MM/YYYY")}`,
        key: 'aumBeginning',
        index: 'totalAUM',
        currency: 'R$'
    },
    {
        title: `Total AUM final ${moment().subtract(1, 'month').format("MM/YYYY")}`,
        key: 'aumEnd',
        index: 'totalAUM',
        currency: 'R$'
    },
    {
        title: `Total de aportes`,
        key: 'totalAportes',
        index: 'totalAportes',
        currency: 'R$'
    },
    {
        title: `Total de resgates`,
        key: 'totalResgates',
        index: 'totalResgates',
        currency: 'R$'
    },
    {
        title: `Total investido (Sem rendimentos)`,
        key: 'somaTotal',
        index: 'somaTotal',
        currency: 'R$'
    },
]

const lucroKeyByType = (type) => {
    const m = {
        spirit: 'lucroSpirit',
        spirit2: 'lucroSpirit2',
        spirit3: 'lucroSpirit3',
        bats: 'lucroBats',
        'capex-senior': 'lucro',
        'capex-sub': 'lucroCapexSub'
    }
    return m[type] || 'lucroSpirit'
}

const OperationsBalance = (props) => {
    const { type, balance, isLoading } = props
    const lucroSaldoKey = lucroKeyByType(type)

    // Soma os valores de aportes e dos primeiros valores investidos
    const getTotalAportes = () => {
        const aportes = balance?.totalAportes?.totalAportes
        const primeiros = balance?.totalPrimeirosValoresInvestidos?.totalPrimeirosValoresInvestidos

        const parsedAportes = parseFloat(aportes ?? 0)
        const parsedPrimeiros = parseFloat(primeiros ?? 0)

        const safeAportes = Number.isFinite(parsedAportes) ? parsedAportes : 0
        const safePrimeiros = Number.isFinite(parsedPrimeiros) ? parsedPrimeiros : 0

        return safeAportes + safePrimeiros
    }

    // Verificação de segurança para evitar erros
    if (!balance || typeof balance !== 'object') {
        return (
            <Row gutter={[15, 15]}>
                <Col md={24}>
                    <Card title="Erro" headStyle={{color: '#ff4d4f', fontWeight: 'bold'}}>
                        <p>Dados de saldo não disponíveis</p>
                    </Card>
                </Col>
            </Row>
        )
    }
    
    return (
        <Row gutter={[15, 15]}>
            {type === 'asa' || type === 'rfy18' || type === 'rfy18-subordinada' ?
                asa.map(i => (
                    <Col md={8} key={i.index}>
                        <Card title={i.title} headStyle={{color: '#0b8369', fontWeight: 'bold'}}>
                            {isLoading ? 'Carregando valor' : 
                                <h4 className="font-bold tx-gray font-28">
                                    {i.currency}
                                    {
                                        i.index === 'somaTotal'
                                        ? maskCurrency(balance[i.key])
                                        : i.index === 'totalAportes'
                                            ? maskCurrency(getTotalAportes())
                                            : (balance[i.key] && balance[i.key][i.index] !== undefined 
                                                ? maskCurrency(balance[i.key][i.index]) 
                                                : '0,00'
                                              )
                                    }
                                </h4>
                            }
                        </Card>
                    </Col>
                )) :
                spirit.map(i => {
                    const saldoKey = i.key === 'lucroSpirit' ? lucroSaldoKey : i.key
                    return (
                    <Col md={8} key={`${String(saldoKey)}-${i.index}`}>
                        <Card title={i.title} headStyle={{color: '#0b8369', fontWeight: 'bold'}}>
                            {isLoading ? 'Carregando valor' : 
                                <h4 className="font-bold tx-gray font-28">
                                    {i.currency}
                                    {i.index === 'desvio' 
                                        ? (balance['saldoQuery'] && balance['saldoQuery']['totalClientesFlow'] !== undefined && balance['saldoQuery']['desvio'] !== undefined 
                                            ? maskCurrency(balance['saldoQuery']['totalClientesFlow'] - balance['saldoQuery']['desvio'])
                                            : '0,00'
                                          )
                                        : i.index === 'somaTotal' 
                                        ? maskCurrency(balance[i.key])
                                        : i.index === 'totalAportes'
                                            ? maskCurrency(getTotalAportes())
                                            : (balance[saldoKey] && balance[saldoKey][i.index] !== undefined 
                                                ? maskCurrency(balance[saldoKey][i.index]) 
                                                : '0,00'
                                              )
                                    }
                                </h4>
                            }
                        </Card>
                    </Col>
                )})
            }
        </Row>
    )
}

export default OperationsBalance